/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Alert, Card, CardBody, Col, Container, Row, Label,
} from 'reactstrap';

// Redux
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';

import * as Yup from 'yup';

// actions
import { apiError, loginUser } from '../../store/actions';
import { getPostLoginRedirectPath } from '../../helpers/auth_redirect';

// import images
import profile from '../../assets/images/DropzoneLogo.png';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.apiError('');
  }

  render() {
    document.title = 'Dropzone Login';
    return (
      <>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2" />
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div>
                    <Row>
                      <Col className="col-12 align-self-end" style={{ padding: '10px 40px' }}>
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="p-2">
                      {this.props.error && this.props.error ? (
                        <Alert color="danger">{this.props.error}</Alert>
                      ) : null}
                      <Formik
                        enableReinitialize
                        initialValues={{
                          user_id:
                            (this.state && this.state.user_id)
                            || '',
                          password:
                            (this.state && this.state.pin) || '',
                        }}
                        validationSchema={Yup.object().shape({
                          user_id: Yup.string().required(
                            'Please Enter Your User ID',
                          ),
                          pin: Yup.string().required(
                            'Please Enter a Valid Pin',
                          ),
                        })}
                        onSubmit={(values) => {
                          const redirectTo = getPostLoginRedirectPath(this.props.location);
                          this.props.loginUser(
                            values,
                            this.props.history,
                            redirectTo,
                          );
                        }}
                      >
                        {({ errors, touched }) => (

                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label for="user_id" className="form-label">
                                User ID
                              </Label>
                              <Field
                                name="user_id"
                                type="number"
                                autoFocus
                                className={
                                  `form-control${
                                    errors.user_id && touched.user_id
                                      ? ' is-invalid'
                                      : ''}`
                                }
                              />
                              <ErrorMessage
                                name="user_id"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="mb-3">
                              <Label for="pin" className="form-label">
                                Pin
                              </Label>
                              <Field
                                name="pin"
                                type="password"
                                autoComplete="true"
                                className={
                                  `form-control${
                                    errors.pin && touched.pin
                                      ? ' is-invalid'
                                      : ''}`
                                }
                              />
                              <ErrorMessage
                                name="pin"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>

                            <div className="mt-4 d-grid">
                              <button
                                className="btn btn-primary btn-block"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  location: PropTypes.object,
  loginUser: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login),
);
